const _publicErrorCode = {
    INTERNAL_CLIENT_ERROR: '0000',
    UNKNOWN_ERROR: '1000',

    ERR_INVALID_ID: '1001',
    ERR_INVALID_LANG: '1002',
    ERR_INVALID_FIELD: '1003',
    ERR_INVALID_PARAM: '1004',
    ERR_INVALID_ACCESS: '1005',
    ERR_NOT_FOUND: '1006',
    ERR_NOT_ENOUGH_POINT: '1007',
    ERR_NOT_REFUNDABLE: '1008',
    ERR_NOT_COMPLETED: '1009',
    ERR_PREVIEW_FIRST: '1010',
    ERR_ALREADY_EXIST: '1011',
    ERR_INTERNAL_ERROR: '1012',
    ERR_INVALID_STATE: '1013',
    ERR_FORGERY: '1014',
    ERR_EXCEED: '1015',
    ERR_LIMITED_FILE_SIZE: '1016',
    ERR_NOT_SUPPORTED_FILE_FORMAT: '1017',
    ERR_LIMITED_FILE: '1018',
    ERR_TEMPLATE_DATA_MISMATCH: '1019',
    ERR_CAN_NOT_GIF_RENDER:"1020",
    ERR_NOT_SUPPORTED: "1023",
    ERR_NOT_ENOUGH: "1024",
    ERR_SERVER_CHECK: "1025",
    ERR_INVALID_ACCESS_AGENCY: "1026",
    HTTP_STATUS_400: '2001',
    HTTP_STATUS_401: '2002',
    HTTP_STATUS_403: '2003',
    HTTP_STATUS_404: '2004',
    HTTP_STATUS_405: '2005',
    HTTP_STATUS_408: '2006',
    HTTP_STATUS_500: '2007',
    HTTP_STATUS_501: '2008',
    HTTP_STATUS_502: '2009',
    HTTP_STATUS_503: '2010',

    EVAL_ERROR: '3001',
    RANGE_ERROR: '3002',
    REFERENCE_ERROR: '3003',
    SYNTAX_ERROR: '3004',
    TYPE_ERROR: '3005',
    URI_ERROR: '3006',
    AGGREGATE_ERROR: '3007',
    INTERNAL_ERROR: '3008',
    NETWORK_ERROR: '3009',
    READ_ONLY_ERROR: '3010',
    CODE_NULL_ERROR: '3011',
    CODE_UNDEFINED_ERROR: '3012',

    CLIENT_TEMPLATE_ERROR: '4001',
    CLIENT_TEMPLATE_ERROR_1: '4001-1',
    CLIENT_NOT_SUPPORTED_APP_METHOD_ERROR: '4002',
    CLIENT_INVALD_DATA_ERROR: '4003'
}

const _privateErrorCode = {
    ERR_INVALID_ID: _publicErrorCode.ERR_INVALID_ID,
    ERR_INVALID_LANG: _publicErrorCode.ERR_INVALID_LANG,
    ERR_INVALID_FIELD: _publicErrorCode.ERR_INVALID_FIELD,
    ERR_INVALID_PARAM: _publicErrorCode.ERR_INVALID_PARAM,
    ERR_INVALID_ACCESS: _publicErrorCode.ERR_INVALID_ACCESS,
    ERR_NOT_FOUND: _publicErrorCode.ERR_NOT_FOUND,
    ERR_NOT_ENOUGH_POINT: _publicErrorCode.ERR_NOT_ENOUGH_POINT,
    ERR_NOT_REFUNDABLE: _publicErrorCode.ERR_NOT_REFUNDABLE,
    ERR_NOT_COMPLETED: _publicErrorCode.ERR_NOT_COMPLETED,
    ERR_PREVIEW_FIRST: _publicErrorCode.ERR_PREVIEW_FIRST,
    ERR_ALREADY_EXIST: _publicErrorCode.ERR_ALREADY_EXIST,
    ERR_INTERNAL_ERROR: _publicErrorCode.ERR_INTERNAL_ERROR,
    ERR_INVALID_STATE: _publicErrorCode.ERR_INVALID_STATE,
    ERR_FORGERY: _publicErrorCode.ERR_FORGERY,
    ERR_EXCEED: _publicErrorCode.ERR_EXCEED,
    ERR_LIMITED_FILE_SIZE: _publicErrorCode.ERR_LIMITED_FILE_SIZE,
    ERR_NOT_SUPPORTED_FILE_FORMAT: _publicErrorCode.ERR_NOT_SUPPORTED_FILE_FORMAT,
    ERR_LIMITED_FILE: _publicErrorCode.ERR_LIMITED_FILE,
    ERR_TEMPLATE_DATA_MISMATCH: _publicErrorCode.ERR_TEMPLATE_DATA_MISMATCH,
    ERR_CAN_NOT_GIF_RENDER: _publicErrorCode.ERR_CAN_NOT_GIF_RENDER,
    ERR_NOT_SUPPORTED: _publicErrorCode.ERR_NOT_SUPPORTED,
    ERR_SERVER_CHECK: _publicErrorCode.ERR_SERVER_CHECK,
    ERR_INVALID_ACCESS_AGENCY: _publicErrorCode.ERR_INVALID_ACCESS_AGENCY,

    400: _publicErrorCode.HTTP_STATUS_400,
    401: _publicErrorCode.HTTP_STATUS_401,
    403: _publicErrorCode.HTTP_STATUS_403,
    404: _publicErrorCode.HTTP_STATUS_404,
    405: _publicErrorCode.HTTP_STATUS_405,
    408: _publicErrorCode.HTTP_STATUS_408,
    500: _publicErrorCode.HTTP_STATUS_500,
    501: _publicErrorCode.HTTP_STATUS_501,
    502: _publicErrorCode.HTTP_STATUS_502,
    503: _publicErrorCode.HTTP_STATUS_503,
    
    EvalError: _publicErrorCode.EVAL_ERROR,
    RangeError: _publicErrorCode.RANGE_ERROR,
    ReferenceError: _publicErrorCode.REFERENCE_ERROR,
    SyntaxError: _publicErrorCode.SYNTAX_ERROR,
    TypeError: _publicErrorCode.TYPE_ERROR,
    URIError: _publicErrorCode.URI_ERROR,
    AggregateError: _publicErrorCode.AGGREGATE_ERROR,
    InternalError: _publicErrorCode.INTERNAL_ERROR,
    'Network Error': _publicErrorCode.NETWORK_ERROR,
    'read-only': _publicErrorCode.READ_ONLY_ERROR,
    'InternalClientError': _publicErrorCode.INTERNAL_CLIENT_ERROR,
    null: _publicErrorCode.CODE_NULL_ERROR,
    undefined: _publicErrorCode.CODE_UNDEFINED_ERROR,

    CLIENT_TEMPLATE_ERROR: _publicErrorCode.CLIENT_TEMPLATE_ERROR,
    CLIENT_TEMPLATE_ERROR_1: _publicErrorCode.CLIENT_TEMPLATE_ERROR_1,
    CLIENT_NOT_SUPPORTED_APP_METHOD_ERROR: _publicErrorCode.CLIENT_NOT_SUPPORTED_APP_METHOD_ERROR,
    CLIENT_INVALD_DATA_ERROR: _publicErrorCode.CLIENT_INVALD_DATA_ERROR
}

export const GetPublicErrorCode = ((errorCode) => _privateErrorCode[errorCode] ? _privateErrorCode[errorCode] : _publicErrorCode.UNKNOWN_ERROR)

export const PRIVATE_ERROR_CODE = _privateErrorCode
export const PUBLIC_ERROR_CODE = _publicErrorCode